module.exports = __webpack_public_path__ + "static/media/plane-icon.df952fa2.svg";